import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useLazyGetUtilityUsersPageQuery } from "../../../../../service/utility-users-service";
import { TeamMemberRow } from "./TeamMemberRow";
import styles from "./teammember.module.scss";
import CommonPagination from "../../../../../common/components/pagination/CommonPagination";
import TeamMemberSideDialog from "./TeamMemberSideDialog";
import SearchInput from "../../../../../common/components/xepp/search-input/SearchInput";


export type TeamMembersTabHandle = {
  openAddNewMember: () => void;
};

export const TeamMembersPage = forwardRef<TeamMembersTabHandle>((props,ref) => {
   

	const pageSize = 6;
	const [currentPage, setCurrentPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");

    const [getUtilityUsers, {data: utilityUsersResponse}] = useLazyGetUtilityUsersPageQuery();
    const [addNewTeamMemberOpen, setAddNewTeamMemberOpen] = useState(false)
    const totalPages = utilityUsersResponse?.totalPages ?? 0;

    useEffect(()=>{
        getUtilityUsers({Page: currentPage,PageSize:pageSize,...(searchTerm && {search: searchTerm})});
    },[getUtilityUsers,currentPage,pageSize,searchTerm])

    const showAddNewTeamMember = () => {
        setAddNewTeamMemberOpen(true);
    }
    const hideAddNewTeamMember = () => {
        setAddNewTeamMemberOpen(false);
    }

    useImperativeHandle(ref, () => ({
        openAddNewMember: showAddNewTeamMember,
    }));

    return (
        <>
                <div className={styles.teamMemberTable}>
                    <div className={styles.searchRow}>
                        <SearchInput
                            placeholder="Search by name or email"
                            className={styles.searchInput}
                            onSearch={(value: string) => {
                                setSearchTerm(value);
                                setCurrentPage(1);
                            }}
                            debounceTime={500}
                        />
                    </div>

                    {
                    utilityUsersResponse != undefined && utilityUsersResponse.items.map( (user, i )=>{
                        return <TeamMemberRow User={user} key={user.id}/>
                        })
                    }
                    <div className={styles.paginationContainer}>
                        <CommonPagination currentPage={currentPage} numberOfPages={totalPages} onPageChange={(page: number) => {
                            setCurrentPage(page)
                        }} />
                    </div>
                </div>
                {addNewTeamMemberOpen && <TeamMemberSideDialog isEdit={false} onCloseDialog={hideAddNewTeamMember} onDone={hideAddNewTeamMember} user={undefined}/>}
                
        </>
    );
});
